import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { portfolioData } from '../mock';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="min-h-screen flex items-center px-6 lg:px-8 bg-[#F8FAFC] pt-24 md:pt-0">
      <div className="max-w-6xl mx-auto w-full">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="mb-6">
              <span className="inline-block px-4 py-2 bg-[#E2E8F0] text-[#1E3A8A] text-sm font-medium rounded-full">
                Web-Entwickler • Kelsterbach
              </span>
            </div>
            
            <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-black leading-[1.1] mb-8 tracking-tight">
              {portfolioData.tagline}
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed mb-12 max-w-2xl">
              {portfolioData.description}
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={() => scrollToSection('contact')}
                size="lg"
                className="bg-[#1E40AF] hover:bg-[#1E3A8A] text-white transition-all px-8 py-7 text-base font-semibold group"
              >
                Kostenloses Erstgespräch
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
              </Button>
              <Button
                onClick={() => scrollToSection('portfolio')}
                size="lg"
                variant="outline"
                className="border-2 border-[#1E40AF] text-[#1E40AF] hover:bg-[#1E40AF] hover:text-white transition-all px-8 py-7 text-base font-semibold"
              >
                Projekte ansehen
              </Button>
            </div>
          </div>
          
          <div className="lg:col-span-5">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?crop=entropy&cs=srgb&fm=jpg&ixid=M3w0NzEyNjJ8MHwxfHNlYXJjaHwxfHxjb2RpbmclMjBsYXB0b3B8ZW58MHx8fHwxNzM3NTgwMDAwfDA&ixlib=rb-4.1.0&q=85"
                alt="Webentwicklung"
                className="w-full h-auto rounded-lg shadow-2xl"
              />
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-[#1E40AF] rounded-lg -z-10"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;